/**
 * Text that carries a hover card, marked with a dotted underline: a value that opens a hover card
 * otherwise looks identical to one that doesn't. Shared so the whole app uses one signal.
 *
 * Only put it on text that actually has a hover.
 */
export const HOVERABLE_TEXT =
  "cursor-help underline decoration-dotted decoration-fg-muted underline-offset-4"
